module.exports = __webpack_public_path__ + "static/media/paymobBlueLogo.d70fc73f.svg";